module.exports = __webpack_public_path__ + "img/404.3ec06ef5.jpg";